'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * ## Stars
 *
 * Displays a set number of stars describing the given value.
 *
 *     This component takes a minimum (optional), maximum and current value and displays
 * that value as stars.
 *
 * ### Properties
 *
 * - `value`: The current value, must be between `min` and `max`.
 * - `max`: The maximum value.
 *     If `value` has this value, then all stars will be filled.
 * - `min` (optional): The minimum value.
 *     If `value` has this value, then no stars will be filled.
 *     Defaults to `0`
 * - `stars` (Optional): The number of stars.
 *     By default 5 stars are used for display, but a custom number
 * can be specified.
 * - `inverse` (Optional): Invert the value.
 *     If set to true, the `value` will be inverted (substracted from `max` + 1).
 * ### Events
 *
 * This is a display-only component, so no events are fired by it.
 *
 * ### Slots
 *
 * This component does not have any slots.
 */
exports.default = {
    name: 'stars',

    template: require('./stars.component.html'),

    props: {
        // The minimum number - The number that is represented by 0 stars
        min: { type: Number, default: 0 },

        // The number of stars to display. Defaults to 5
        stars: { type: Number, default: 5 },

        // The maximum number, representing the maximum number of stars
        max: { type: Number, required: true },

        // The current value
        value: { required: true },

        // Invert the value
        inverse: { type: Boolean, default: false }
    },

    data: function data() {
        return {
            starsToRender: []
        };
    },


    // Render data on initialization
    mounted: function mounted() {
        this.starsToRender = this.prepareStars();
    },


    methods: {

        /**
         * Prepares the stars that are to be rendered.
         * @returns {Array}
         */
        prepareStars: function prepareStars() {
            var stars = [];
            var valueOfOneStar = (this.max - this.min) / this.stars;
            var finalValue = this.inverse ? this.max + 1 - this.value : this.value;
            for (var i = 0; i < this.stars; i++) {
                var value = (i + 1) * valueOfOneStar + this.min;
                stars.push(value <= parseInt(finalValue));
            }
            return stars;
        }
    },

    watch: {
        min: function min(_min) {
            this.min = _min;
            this.starsToRender = this.prepareStars();
        },
        max: function max(_max) {
            this.max = _max;
            this.starsToRender = this.prepareStars();
        },
        value: function value(_value) {
            this.value = _value;
            this.starsToRender = this.prepareStars();
        },
        stars: function stars(_stars) {
            this.stars = _stars;
            this.starsToRender = this.prepareStars();
        }
    }

};